import React from 'react';
import './ConceptSection.css';

const ConceptSection = () => {
  return (
    <section className="concept-section fade-in">
      <div className="container">
        <h2 className="heading-art-deco heading-medium">
          THE RECAP, le concept
        </h2>
        <h3 className="concept-subtitle">
          The Recap est un format imaginé par Laetitia Lamari et Adrien Næem pour permettre aux entreprises de bénéficier des enseignements des grands événements du retail et du e-commerce, sans avoir à s'y rendre.
        </h3>
        <div className="concept-body-text">
          <p>
            Animateurs du podcast Le Café de l'E-Commerce, Laetitia Lamari et Adrien Næem analysent depuis plusieurs années les transformations du secteur. Experts du retail et du e-commerce, ils évoluent au cœur de l'écosystème depuis plusieurs années, entre contenus, événements et analyses terrain.
          </p>
          <p>
            Pour The Recap, ils se déplacent sur les événements, assistent aux conférences, rencontrent les acteurs du secteur et analysent ce qui s'y joue.
          </p>
          <p>
            À l'issue de ces rendez-vous, ils proposent une restitution claire, structurée et synthétique des tendances, innovations et stratégies observées.
          </p>
          <p>
            The Recap se décline ensuite à travers plusieurs formats et temps forts, pensés pour partager l'essentiel, prendre du recul et offrir une vision concrète et exploitable aux professionnels du retail et du e-commerce.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ConceptSection;
